import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../ui/card";
import { Button } from "../../ui/button";
import { Loader2, Play, Square, Activity, AlertTriangle } from "lucide-react";
import { useToast } from "../../../contexts/ToastContext";
import { api } from "../../../services/api";

export function TradingDataControl() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    setLoading(true);
    const result = await api.startTradingData();
    if (result.success) {
      showToast({
        type: 'success',
        title: 'Berhasil',
        message: 'Trading Data Collector berhasil dijalankan'
      });
    } else {
      showToast({
        type: 'error',
        title: 'Gagal',
        message: result.error || 'Gagal menjalankan Trading Data Collector'
      });
    }
    setLoading(false);
  };

  const handleStop = async () => {
    setLoading(true);
    const result = await api.stopTradingData();
    if (result.success) {
      showToast({
        type: 'success',
        title: 'Berhasil',
        message: 'Trading Data Collector berhasil dihentikan'
      });
    } else {
      showToast({
        type: 'error',
        title: 'Gagal',
        message: result.error || 'Gagal menghentikan Trading Data Collector'
      });
    }
    setLoading(false);
  };

  return (
    <Card className="mb-6 overflow-hidden border-t-4 border-t-red-500 shadow-lg">
      <CardHeader className="bg-muted/30 pb-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-500/10 rounded-lg">
              <Activity className="w-6 h-6 text-red-600" />
            </div>
            <div>
              <CardTitle className="text-xl">Trading Data Manual Trigger</CardTitle>
              <CardDescription>Jalankan pengumpulan data Orderbook & Running Trade secara manual untuk testing</CardDescription>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="flex items-center gap-3 text-amber-600 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-xl border border-amber-200 dark:border-amber-800 flex-1">
            <AlertTriangle className="w-5 h-5 flex-shrink-0" />
            <p className="text-sm">
              Sistem otomatis dimatikan. Klik tombol di kanan untuk menjalankan pengumpulan data <strong>MDKA selama 5 detik</strong> sebagai pengetesan.
            </p>
          </div>
          
          <div className="flex gap-3 w-full md:w-auto">
            <Button 
              variant="outline" 
              onClick={handleStop} 
              disabled={loading}
              className="flex-1 md:flex-none h-12 px-6 border-red-200 hover:bg-red-50 hover:text-red-600 text-red-500"
            >
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Square className="w-4 h-4 mr-2" />}
              FORCE STOP
            </Button>
            
            <Button 
              onClick={handleStart} 
              disabled={loading}
              className="flex-1 md:flex-none h-12 px-6 bg-green-600 hover:bg-green-700"
            >
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Play className="w-4 h-4 mr-2" />}
              TRIGGER MDKA (5s)
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
